import { FormattedMessage } from 'react-intl';

import { AddToSlackButton } from '@/components/global/InstallSlack';

export const WelcomeCard = (): JSX.Element => {
  return (
    <div className="grid md:grid-cols-2 gap-8 items-center">
      <div className="space-y-6">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            <FormattedMessage id="gettingStarted.welcomeCard.title" />
          </h2>
          <div className="space-y-4 text-gray-700 dark:text-gray-300">
            <p className="leading-relaxed">
              <FormattedMessage id="gettingStarted.welcomeCard.description1" />
            </p>
            <p className="leading-relaxed">
              <FormattedMessage id="gettingStarted.welcomeCard.description2" />
            </p>
          </div>
        </div>

        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-r from-green-400 to-green-600 flex items-center justify-center">
              <div className="w-2 h-2 rounded-full bg-white"></div>
            </div>
            <span className="text-gray-700 dark:text-gray-300">
              <FormattedMessage id="gettingStarted.welcomeCard.features.analysis" />
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-r from-blue-400 to-blue-600 flex items-center justify-center">
              <div className="w-2 h-2 rounded-full bg-white"></div>
            </div>
            <span className="text-gray-700 dark:text-gray-300">
              <FormattedMessage id="gettingStarted.welcomeCard.features.integration" />
            </span>
          </div>
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-r from-purple-400 to-purple-600 flex items-center justify-center">
              <div className="w-2 h-2 rounded-full bg-white"></div>
            </div>
            <span className="text-gray-700 dark:text-gray-300">
              <FormattedMessage id="gettingStarted.welcomeCard.features.monitoring" />
            </span>
          </div>
        </div>
      </div>

      <div className="text-center space-y-6">
        <div className="p-6 bg-gradient-to-br from-blue-50 to-purple-50 dark:from-blue-900/30 dark:to-purple-900/30 rounded-xl border border-blue-200/50 dark:border-blue-700/50">
          <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
            <FormattedMessage id="gettingStarted.welcomeCard.getStarted.title" />
          </h3>
          <p className="text-gray-600 dark:text-gray-300 mb-6">
            <FormattedMessage id="gettingStarted.welcomeCard.getStarted.description" />
          </p>
          <AddToSlackButton variant="slack" />
          <div className="mt-4 text-center">
            <div className="text-sm text-gray-600 dark:text-gray-400">
              <FormattedMessage id="gettingStarted.welcomeCard.getStarted.communityPrefix" />{' '}
              <a
                href="https://join.slack.com/t/anyshift-community/shared_invite/zt-319lc26f9-QB3eyA0uJFwRKD78iN_k7g"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 underline font-medium transition-colors duration-200"
              >
                <FormattedMessage id="gettingStarted.welcomeCard.getStarted.communityLink" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
